// honorb4

/*
Scripts File
*/

// as the page loads, call these scripts
jQuery(document).ready(function ($) {
	// flatten object by concatenating values
	function concatValues(obj) {
		var value = '';
		for (var prop in obj) {
			value += obj[prop];
		}
		return value;
	}


	/* getting viewport width */
	var responsive_viewport = $(window).width();

	/* if is above or equal to 768px */
	if (responsive_viewport >= 768) {
		/* load gravatars */
		$('.comment img[data-gravatar]').each(function () {
			$(this).attr('src', $(this).attr('data-gravatar'));
		});
	}

	/* off the bat large screen actions */
	if (responsive_viewport > 1030) {}

	$(".open-video").click(function () {
		$(".popup-video").slideDown(function () {
			$('iframe[src*="vimeo.com"]').each(function () {
				$f(this).api('play');
			});
			$('#bgvid').get(0).pause();
		});
	});

	$(".popup-video").click(function () {
		$(".popup-video").slideUp(function () {});
		$('iframe[src*="vimeo.com"]').each(function () {
			$f(this).api('pause');
		});
		$('#bgvid').get(0).play();
	});

	// Mobile Menu Icon
	$(".mobile-nav-icon").click(function () {
		$(".mobile-menu-container").slideToggle(function () {
			// Animation complete.
		});
	});

	// Guiding Principles
	const principles = [1, 2, 3, 4, 5, 6];

	principles.forEach(function (num) {
		$("#principle" + num + " .open").click(function () {
			$('.principle, .principle-popup').removeClass("active");
			$("#principle" + num).addClass("active");
			$("#principle" + num + "-popup").addClass("active");
		});
	});

	$(".close-btn").click(function () {
		$('.principle, .principle-popup').removeClass("active");
	});

	// Waypoint counters
	if ($(".home")[0] || $("#page-5654")[0] || $(".page-template-template-home-temporary")[0] ) {
		$('#count-one').waypoint(function (direction) {
			const option = { separator: '', decimal: '', duration: 4 };
			const optionsplus = { useEasing: true, useGrouping: true, suffix: '+', separator: '', decimal: '', enableScrollSpy: true, scrollSpyDelay: 300, scrollSpyOnce: true, duration: 5 };
			const optionszero = { prefix: '0', separator: '', decimal: '', enableScrollSpy: true, scrollSpyDelay: 100, scrollSpyOnce: true, duration: 2 };



			let upone = new CountUp('count-one', 450, optionsplus);
			let uptwo = new CountUp('count-two', 1300, optionsplus);
			let upthree = new CountUp('count-three', 3700, optionsplus);
			let upfour = new CountUp('count-four', 700, option);
			let upfive = new CountUp('count-five', 11, option);
			let upsix = new CountUp('count-six', 6000, optionsplus);


			if (!upone.error) {
				upone.start();
				uptwo.start();
				upthree.start();
				upfour.start();
				upfive.start();
				upsix.start();
			} else {
				console.error(upone.error);
			}
		}, {
			offset: '50%',
			triggerOnce: false
		});
	}

	// Function to enable smooth scrolling for anchor links
	function enableSmoothScrolling() {
		$('a[href*="#"]')
			.not('[href="#"]')
			.not('[href="#0"]')
			.click(function (event) {
				if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
					location.hostname == this.hostname) {
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
					if (target.length) {
						event.preventDefault();
						$('html, body').animate({
							scrollTop: target.offset().top
						}, 1000, function () {
							var $target = $(target);
							$target.focus();
							if (!$target.is(":focus")) {
								$target.attr('tabindex', '-1');
								$target.focus();
							}
						});
					}
				}
			});
	}

	// Call the function after the page has fully loaded
	$(document).ready(function () {
		enableSmoothScrolling();
	});

	/* Scripts to run after page elements are loaded (images, iframes, etc..) */
	$(window).on('load', function () {
		// Check if the page template is the one we're interested in
		if ($(".page-template-template-partners-23")[0]) {
			var $grid = $('#isotope-list').isotope({
				itemSelector: '.item',
				percentPosition: true,
				layoutMode: 'fitRows',
				filter: '.foundation-partners',
				fitRows: {
					columnWidth: '.grid-sizer'
				}
			});

			var currentGroupFilter = '.foundation-partners';
			var currentStarFilter = '';

			function setOrUnsetIsSelected() {
				if (currentGroupFilter === '.corporate-partners') {
					$('li[data-filter="*"]').addClass('is-checked');
				} else {
					$('li[data-filter="*"]').removeClass('is-checked');
				}
			}

			setOrUnsetIsSelected();

			$('.filters').on('click', 'li', function (event) {
				var $button = $(event.currentTarget);
				var filterValue = $button.attr('data-filter');
				var filterGroup = $button.parent().attr('data-filter-group');

				if (filterGroup === "group") {
					if (currentGroupFilter === '.corporate-partners' && filterValue !== '.corporate-partners') {
						$(".starimage .icon").hide();
						$('.buttons.buttonstar').removeClass('is-checked');
					}
					currentGroupFilter = filterValue;

					if (filterValue === '.corporate-partners') {
						$('.starlist').removeClass('displaynone').addClass('display');
					} else {
						$('.starlist').removeClass('display').addClass('displaynone');
						currentStarFilter = '';
					}
					setOrUnsetIsSelected();
				} else if (filterGroup === "star" && currentGroupFilter === '.corporate-partners') {
					currentStarFilter = filterValue;
				}
				$grid.isotope({ filter: currentGroupFilter + currentStarFilter });
			});

			$('.button-group').each(function (i, buttonGroup) {
				var $buttonGroup = $(buttonGroup);
				$buttonGroup.on('click', 'li', function (event) {
					$buttonGroup.find('.is-checked').removeClass('is-checked');
					var $button = $(event.currentTarget);
					$button.addClass('is-checked');
				});
			});
		}

		if ($(".post-type-archive-testimonial")[0]) {
			var $containerTestimonials = $('.branchlist');
			$containerTestimonials.isotope({
				itemSelector: '.item',
				percentPosition: true,
				layoutMode: 'masonry'
			});

			var $optionSetspeople = $('#filtertestimonials'),
				$optionLinkspeople = $optionSetspeople.find('a');

			$optionLinkspeople.click(function () {
				var $thisPeople = $(this);
				if ($thisPeople.hasClass('selected')) {
					return false;
				}
				var $optionSetPeople = $thisPeople.parents('#filtertestimonials');
				$optionSetspeople.find('.selected').removeClass('selected');
				$thisPeople.addClass('selected');

				var selector = $thisPeople.data('filter');
				$containerTestimonials.isotope({
					filter: selector
				});

				return false;
			});
		}

		if ($(".blog ")[0]) {
			var $container = $('#isotope-list');
			$container.isotope({
				itemSelector: '.item',
				percentPosition: true,
				layoutMode: 'masonry'
			});

			var $optionSets = $('#filters'),
				$optionLinks = $optionSets.find('a');

			$optionLinks.click(function () {
				var $this = $(this);
				if ($this.hasClass('selected')) {
					return false;
				}
				var $optionSet = $this.parents('#filters');
				$optionSets.find('.selected').removeClass('selected');
				$this.addClass('selected');

				var selector = $(this).attr('data-filter');
				$container.isotope({
					filter: selector
				});

				return false;
			});
		}


		if ($(".page-template-template-tribes")[0] || $(".tax-tribe-categories")[0] || $(".post-type-archive-event")[0]) {
			var $container = $('#isotope-list');
			$container.isotope({
				itemSelector: '.item',
				percentPosition: true,
				layoutMode: 'fitRows'
			});

			var $optionSets = $('#filters'),
				$optionLinks = $optionSets.find('a');

			$optionLinks.click(function () {
				var $this = $(this);
				if ($this.hasClass('selected')) {
					return false;
				}
				var $optionSet = $this.parents('#filters');
				$optionSets.find('.selected').removeClass('selected');
				$this.addClass('selected');

				var selector = $(this).attr('data-filter');
				$container.isotope({
					filter: selector
				});

				return false;
			});
		}

		if ($(".page-template-template-people")[0]) {
			var $containerPeople = $('#isotope-list');
			$containerPeople.isotope({
				itemSelector: '.item',
				percentPosition: true,
				filter: '.staff',
				layoutMode: 'fitRows',
				fitRows: {
					columnWidth: '.grid-sizer'
				}
			});

			var $optionSetspeople = $('#filters'),
				$optionLinkspeople = $optionSetspeople.find('a');

			$optionLinkspeople.click(function () {
				var $thisPeople = $(this);
				if ($thisPeople.hasClass('selected')) {
					return false;
				}
				var $optionSetPeople = $thisPeople.parents('#filters');
				$optionSetspeople.find('.selected').removeClass('selected');
				$thisPeople.addClass('selected');

				var selector = $thisPeople.data('filter');
				$containerPeople.isotope({
					filter: selector
				});

				return false;
			});
		}

// possibly not needed anymore
//var $container = $('#isotope-list');
// 		var $filter = $('#filters');
// 		var isotopeInstance;
//
// 		function initializeIsotope() {
// 			isotopeInstance = $container.isotope({
// 				filter: '*',
// 				layoutMode: 'fitRows',
// 				animationOptions: {
// 					duration: 750,
// 					easing: 'linear'
// 				}
// 			});
//
// 			$filter.find('a').click(function () {
// 				var selector = $(this).attr('data-filter');
// 				$filter.find('a').removeClass('selected');
// 				$(this).addClass('selected');
// 				$container.isotope({
// 					filter: selector,
// 					animationOptions: {
// 						duration: 750,
// 						easing: 'linear',
// 						queue: false
// 					}
// 				});
//
// 				return false;
// 			});
// 		}
//
// 		function handleIsotope() {
// 			var screenWidth = $(window).width();
// 			if (screenWidth <= 575) {
// 				if (isotopeInstance) {
// 					$container.isotope('destroy');
// 					isotopeInstance = null;
// 				}
// 			} else {
// 				if (!isotopeInstance) {
// 					initializeIsotope();
// 				}
// 			}
// 		}
//
// 		handleIsotope();
//
// 		$(window).resize(function () {
// 			handleIsotope();
// 		});
		//
		var headerHeight = $('.header').outerHeight();
		if ($(".header").css("position") === "fixed") {
			$('body').css('padding-top', headerHeight + 'px');
		} else if ($(".header").css("position") === "relative") {
			$('body').css('padding-top', 0 + 'px');
		}

		$(window).resize(function () {
			var headerHeight = $('.header').outerHeight();
			if ($(".header").css("position") === "fixed") {
				$('body').css('padding-top', headerHeight + 'px');
			} else if ($(".header").css("position") === "relative") {
				$('body').css('padding-top', 0 + 'px');
			}
		});
	});

	// Interests compiler
	$("input[name='interest']").click(function () {
		var modalInterests = [];
		var modalList = $("input[name='00N37000006DWJm']");

		$.each($("input[name='interest']:checked"), function () {
			modalInterests.push($(this).val());
			var modalInterestsJoined = modalInterests.join(";");
			modalList.val(modalInterestsJoined);
		});
	});

	// Clears text field when user clicks
	$("input[type='text']").click(function () {
		$(this).val('');
	});
	// match height of donate elements
	$('.match').matchHeight({ property: 'height' });

	if ($('body.home').length) {
		$(".testimonialbody .col-12:before").fitText(1.2);
		$('ol.carousel-inner li.carousel-item:first').addClass('active');
		$('.carousel-fade').carousel({ interval: 6000 });
	}
});

/*! A fix for the iOS orientationchange zoom bug.
Script by @scottjehl, rebound by @wilto.
MIT License.
*/
(function (w) {
	if (!(/iPhone|iPad|iPod/.test(navigator.platform) && navigator.userAgent.indexOf("AppleWebKit") > -1)) {
		return;
	}
	var doc = w.document;
	if (!doc.querySelector) {
		return;
	}
	var meta = doc.querySelector("meta[name=viewport]"),
		initialContent = meta && meta.getAttribute("content"),
		disabledZoom = initialContent + ",maximum-scale=1",
		enabledZoom = initialContent + ",maximum-scale=10",
		enabled = true,
		x, y, z, aig;
	if (!meta) {
		return;
	}

	function restoreZoom() {
		meta.setAttribute("content", enabledZoom);
		enabled = true;
	}

	function disableZoom() {
		meta.setAttribute("content", disabledZoom);
		enabled = false;
	}

	function checkTilt(e) {
		aig = e.accelerationIncludingGravity;
		x = Math.abs(aig.x);
		y = Math.abs(aig.y);
		z = Math.abs(aig.z);
		if (!w.orientation && (x > 7 || ((z > 6 && y < 8 || z < 8 && y > 6) && x > 5))) {
			if (enabled) {
				disableZoom();
			}
		} else if (!enabled) {
			restoreZoom();
		}
	}
	w.addEventListener("orientationchange", restoreZoom, false);
	w.addEventListener("devicemotion", checkTilt, false);
})(this);
